module.exports = __webpack_public_path__ + "static/media/registration_mail.bc61e935.svg";